import { POPOUT_V2_QUERY, POPOUT_V2_VALUE } from 'owa-popout-v2/lib/utils/constants';
import { getQueryStringParameter } from 'owa-querystring';

export default function isPopoutV2(): boolean {
    return getQueryStringParameter(POPOUT_V2_QUERY) == POPOUT_V2_VALUE;
}
